import { SESSION_STORAGE_CONSTANTS} from "../constants/constants";

export class DataStorage {
    static getDeepLink():string | null {
        return sessionStorage.getItem(SESSION_STORAGE_CONSTANTS.URL_PARAMS) || null;
    }
    static setDeepLink(value:string) {
        value && sessionStorage.setItem(SESSION_STORAGE_CONSTANTS.URL_PARAMS, value);
    }
    static removeDeepLink() {
        sessionStorage.removeItem('url_params');
    }
}
 
export default new DataStorage();